import { Component, Input, OnInit } from '@angular/core';
import { ProductItems } from '../../../../../../models/product/get-product-request';

@Component({
  selector: 'product-availability-view',
  templateUrl: './product-availability-view.component.html',
  styleUrls: ['./product-availability-view.component.scss'],
})
export class ProductAvailabilityViewComponent implements OnInit {
  @Input() productItem: ProductItems | null = null;

  constructor() {}

  ngOnInit(): void {}

  get availabilityStatus(): string {
    if (!this.productItem) {return 'Unknown';}
    return this.productItem.IsEnable ? 'Available' : 'Disabled';
  }

  get availabilityDescription(): string {
    if (!this.productItem) {return '';}

    if (this.productItem.IsEnable) {
      return 'This product is currently available for customers to order.';
    } else {
      return 'This product is currently disabled and not available for ordering.';
    }
  }

  get excludedStores(): string[] {
    // This would need to be populated from the actual excluded stores data
    // For now, returning sample data to match the image
    return ['The Marketplace - Uptown BGC'];
  }

  get totalLocations(): number {
    // This would need to be the total number of merchant locations
    // For now, returning placeholder value
    return 0;
  }

  get availableLocations(): number {
    return this.totalLocations - this.excludedStores.length;
  }

  get availabilityIcon(): string {
    return this.productItem?.IsEnable ? 'check_circle' : 'cancel';
  }

  get availabilityColor(): string {
    return this.productItem?.IsEnable ? 'success' : 'disabled';
  }
}
